<template>
  <v-card
    color="cardSurface"
    :outlined="$vuetify.theme.dark"
    @click="clickCard"
    active-class="building-active"
  >
    <v-img
      v-if="!loading"
      :src="imageSrc"
      :lazy-src="imageSrc"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      :height="100"
    >
      <slot name="btn"> </slot>
      <v-card-title
        class="notranslate headline font-weight-bold font titleFix"
        v-text="title"
      ></v-card-title>
      <v-card-subtitle v-if="subtitle" class="yellow--text">
        {{ subtitle }}
      </v-card-subtitle>
    </v-img>
    <v-skeleton-loader
      v-else
      class="mx-auto"
      max-height="100"
      type="image"
    ></v-skeleton-loader>

    <v-card-actions v-if="!building && !loading" class="justify-space-between">
      <div>
        <slot name="btnLeftDown">
          <v-btn v-if="checkedIn" color="cardBtnBadge" depressed>
            På Byggeplass
          </v-btn>
        </slot>
      </div>

      <div>
        <slot name="btnCenter" hide-details></slot>
      </div>

      <slot name="btnRightDown">
        <v-btn text>
          Se prosjekt
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </slot>
    </v-card-actions>
    <v-card-actions v-if="loading" class="justify-space-between">
      <v-skeleton-loader
        v-if="!isTrysilhus"
        class="projectLoaderBtn"
        type="button"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="projectLoaderBtn"
        type="button"
      ></v-skeleton-loader>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  props: {
    value: {
      type: String,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    // src: {
    //   type: String,
    // },
    btn: {
      type: String,
    },
    building: {
      type: Boolean,
    },
    id: {
      type: Number,
    },
    projTypeId: {
      type: Number,
    },
    imageSrc: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    checkedIn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickCard() {
      this.$emit("click");
    },
  },
  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
    }),
    src: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit("input", value);
      },
    },
  },
});
</script>

<style lang="scss">
.building-active {
  outline: 3px solid var(--v-primary-base);
}

.projectLoaderBtn {
  .v-skeleton-loader__button {
    width: 105px;
  }
}

.titleFix {
  display: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
